/* globals events, google, module */

const GoogleMap = {
  componentName: 'google-map',

  template: `<div class="google-map" :id="name"></div>`,

  props: {
    name: '',
    markers: '',
    center: {
      default () {
        return false;
      }
    },
    autoCenter: {
      default () {
        return true;
      }
    },
    autoZoom: {
      default () {
        return true;
      }
    },
    // this affects the auto-zoom, not the user's ability to zoom
    zoomMax: {
      default () {
        return 14;
      }
    },
    // this affects the auto-zoom, not the user's ability to zoom
    zoomMin: {
      default () {
        return 6;
      }
    },
    zoomStart: {
      default () {
        return false;
      }
    },

    // large markers may be clipped at the map boundary when fit bounds is run
    // this adds padding to the boundary in px
    boundaryPadding: {
      default () {
        return this.$gmapsOptions.boundaryPadding || 0;
      }
    },
    styles: {
      type: Array,
      default () {
        return [];
      }
    },
    hideControlsWidth: {
      default () {
        return false;
      }
    },
    config: {
      type: Object,
      default () {
        return {};
      }
    }
  },

  data: function () {
    return {
      mapInstance: {},
      defaultConfig: {
        zoom: this.zoomStart || this.zoomMax,
        scrollwheel: false,
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: true,
        streetViewControl: true,
        rotateControl: true,
        fullscreenControl: true,
        styles: this.styles
      }
    };
  },

  mounted: function () {
    const element = document.getElementById(this.name);

    this.$gmaps().then((gm) => {
      const options = this.getConfig();

      if (this.center) {
        options.center = new gm.LatLng(
          this.center.latitude, this.center.longitude
        );
      }

      this.mapInstance = new gm.Map(element, options);

      this.$emit('map-intialized', this.mapInstance);
      events.$emit('map-intialized', this.mapInstance);

      if (this.hideControlsWidth) {
        this.hideControlsByWidth(window.innerWidth);
        gm.event.addDomListener(window, 'resize', () => {
          this.hideControlsByWidth(window.innerWidth);
        });
      }

      if (this.autoZoom) {
        gm.event.addListener(this.mapInstance, 'zoom_changed', () => {
          if (this.mapInstance.getZoom() > this.zoomMax) {
            this.mapInstance.setZoom(this.zoomMax);
          }
          if (this.mapInstance.getZoom() < this.zoomMin) {
            this.mapInstance.setZoom(this.zoomMin);
          }
        });
      }
    });
  },

  watch: {
    markers: function (newVal, oldVal) {
      if (oldVal && typeof oldVal.forEach !== 'undefined') {
        oldVal.forEach((m) => { m.setMap(null); });
      }

      if (newVal && typeof newVal.forEach !== 'undefined') {
        newVal.forEach((m) => {
          m.setMap(this.mapInstance);
        });
      }

      this.autoZoomMap();
    }
  },

  methods: {
    getConfig: function () {
      const localConfig = this.config;
      const gDefault = this.defaultConfig;
      const globalConfig = this.$gmapsDefaults;

      return {
        ...gDefault,
        ...globalConfig,
        ...localConfig
      };
    },

    autoZoomMap: function () {
      if (!this.hasMarkers()) {
        return;
      }

      if (this.autoCenter) {
        const bounds = this.getMarkerBounds();
        this.mapInstance.fitBounds(bounds, this.boundaryPadding);
      }
    },

    hasMarkers: function () {
      return this.markers.length;
    },

    getMarkerBounds: function () {
      var markerBounds = new google.maps.LatLngBounds();
      this.markers.map((marker) => {
        markerBounds.extend(marker.position);
      });
      return markerBounds;
    },

    getMarkerBoundsCenter: function () {
      return this.getMarkerBounds().getCenter();
    },

    hideControlsByWidth: function (width) {
      if (!this.hideControlsWidth) {
        return;
      }

      this.mapInstance.setOptions({
        zoomControl: this.getControlValueByWidth(width, 'zoomControl'),
        mapTypeControl: this.getControlValueByWidth(width, 'mapTypeControl'),
        scaleControl: this.getControlValueByWidth(width, 'scaleControl'),
        streetViewControl: this.getControlValueByWidth(width, 'streetViewControl'),
        rotateControl: this.getControlValueByWidth(width, 'rotateControl'),
        fullscreenControl: this.getControlValueByWidth(width, 'fullscreenControl')
      });
    },

    getControlValueByWidth: function (width, control) {
      const config = this.getConfig();

      if (!(control in config)) {
        console.error(
          `The given maps configuration key ${control} is not defined or has been unset in any map config array.`
        );

        return;
      }

      return (width > this.hideControlsWidth) ? this.config[control] : false;
    }
  }
};

module.exports = GoogleMap;
